angular.module('sample.widgets.savedSearches', ['adf.provider',
  "ngResource",
  "ivpusic.cookie",
  "EICDataStream3.resources",
  "ui.router",
  'ui.bootstrap.tooltip'])
  .config(['dashboardProvider', function (dashboardProvider) {
    dashboardProvider
      .widget('savedSearches', {
        id: 'savedSearches',
        title: 'Saved Project/Contract Award Searches',
        description: 'Displays a list of saved searches',
        controller: 'SavedSearchesController',
        //   controllerAs: 'list',
        templateUrl: '/app-ds3/dashboard/widgets/savedSearches/savedSearches.partial.html' //,
        //            edit:         {
        //              templateUrl: '/app/angular-dashboard-framework/widgets/linklist/edit.html',
        //              reload:      false,
        //              controller:  'linklistEditCtrl'
        //            }
      });
  }])
  .controller('SavedSearchesController', ['$scope', 'savedSearches', 'savedSearchListItems', '$state',
    function ($scope, savedSearches, savedSearchListItems, $state) {
      $scope.componentName = "SavedSearchesController";

      $scope.savedQueries = [];

      $scope.getSavedQueries = function () {
        $scope.savedQueries = savedSearchListItems.query(function () {
          $scope.savedQueries.map(function (item) {
            item.originalLabel = item.label;
          });
          $scope.selectedQuery = $scope.savedQueries[0];
        });
      };

      $scope.selectSavedSearch = function (item) {
        var newState = "search." + (item.searchSubject + ' Summary').toCamelCase();
        $state.go(newState, { guid: item.value, name: item.label.urlEncode() });
      };

      $scope.$watch("")


      $scope.selectForDelete = function (item) {
        var returnClass = {
          'fa fa-circle-thin fa-lg': $scope.isDeleting && !item.isDeleting,
          'fa fa-ban fa-lg': $scope.isDeleting && item.isDeleting,
          'alert-text': item.isDeleting,
          'normal-text': !item.isDeleting
        };

        // var returnClass = "dummyClass";

        // if($scope.isDeleting){
        //   returnClass = "fa fa-circle-thin fa-lg";
        // }
        // if ($scope.isDeleting && item.isDeleting ) {
        //   returnClass = "fa fa-ban fa-lg";
        // }

        return returnClass;
      };

      $scope.noSearchesToDelete = function () {
        if (!$scope.isDeleting) return true;

        var any = true;
        $scope.savedQueries.map(function (item) {
          if (item.isDeleting) {
            any = false;
          }
        });
        return any;
      };

      $scope.btnCancel = function () {
        $scope.isDeleting = false;
        $scope.isEditing = false;
        $scope.savedQueries.map(function (item) {
          item.isDeleting = false;
          item.isEditing = false;
          item.label = item.originalLabel;

        });
      };

      $scope.btnDelete = function () {
        $scope.isDeleting = false;
        $scope.savedQueries.map(function (item) {
          if (item.isDeleting) {
            savedSearches.delete({ guid: item.value }, function () {
              $scope.getSavedQueries();
            });
          }
        });
      };




      $scope.btnRename = function () {
        // Stage 1 validate that
        //  a. each list has a name
        //  b. the name has not already been used
        // if these two conditions are not met, highlight the offending names,
        // put up a message and abort before actually renaming the lists
        var allOK = true;

        $scope.savedQueries.map(function (item) {
          // before performing the validation, remove multiple spaces
          // from the proposed name, replacing with single spaces
          item.label = item.label.replace(/\s{2,}/g, ' ');

          if (item.label == "" || isDuplicated($scope.savedQueries, item.label)) {
            item.validated = false;
            allOK = false;
          }
          else {
            item.validated = true;
          }
        });

        if (allOK) {
          $scope.isEditing = false;
          $scope.savedQueries.map(function (item) {
            if (item.label != item.originalLabel) {
              item.originalLabel = item.label
              savedSearchListItems.rename({ searchGuid: item.value }, item);
            }
          });
        }
      };



      var isDuplicated = function (list, name) {
        var duplicates = 0;
        list.map(function (item) {
          if (item.label.toLowerCase() == name.toLowerCase()) duplicates++;
        });

        return (duplicates > 1); // that  is, not counting the item itself
      };

      $scope.validationCheck = function (itemValidated) {
        if (itemValidated) return "ng-valid";
        else return "ng-invalid";

        //      if (itemValidated) return { "border-color": "black" };
        //      else return { "border-color": "red" };
      }


      $scope.select = function (item) {
        if (!$scope.isDeleting && !$scope.isEditing) {
          $scope.selectSavedSearch(item);
        }
      };



      $scope.$on('$viewContentLoaded', function () {
        $scope.getSavedQueries();
        //$scope.getLastSearch();
      });
      $scope.$emit('$viewContentLoaded');


    }]);

